import type { SessionParent } from '@buildautomaton/types';

export type { SessionParent };

/** Prompt / cloud may still send legacy `session_worktrees_root` once. */
export function parseSessionParent(v: unknown): SessionParent | null {
  if (v === 'bridge_root' || v === 'worktrees_root') return v;
  if (v === 'session_worktrees_root') return 'worktrees_root';
  return null;
}
